import React, { FC } from 'react'
import { StoryHeaderAction } from '../../../modules/Feed/components/StoryHeader/StoryHeaderAction'
import { Button, Dropdown } from '@wmgtech/legato'
import { cn } from '../../../shared/utils'
import { TStoryActionOption } from '../../../shared/types'

type TStoryActionsDropdownProps = {
  actions: TStoryActionOption[]
}

export const StoryActionsDropdown: FC<TStoryActionsDropdownProps> = (props) => {
  const { actions } = props
  const actionsToShow = actions.filter((action) => !action.hidden)
  return actionsToShow.length > 0 ? (
    <Dropdown
      placement={'bottomLeft'}
      list={actionsToShow}
      getElement={(option) => <StoryHeaderAction action={option} />}
    >
      <Button
        data-edit-mode
        className={cn('story-header__menu')}
        icon="ellipsis"
        colorType="secondary-black"
        containerStyle="outline"
        size="md"
      />
    </Dropdown>
  ) : null
}
